import React, { useContext } from 'react';
const defaultConfig = {
    isButtonGroup: false,
};
export const ButtonGroupContext = React.createContext(defaultConfig);
export const useButtonGroup = () => useContext(ButtonGroupContext);
